// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  background: #f8fafc;
  color: #1e293b;
  line-height: 1.6;
}

/* Main Container */
.structure-main-container {
  background-color: rgb(255, 255, 255);
  padding: 2rem;
}

/* Header Section */
.structure-header {
  margin-bottom: 2rem;
}

.structure-header-content {
  max-width: 1400px;
  margin: 0 auto;
}

.structure-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  color: white;
}

.structure-title-icon {
  font-size: 3rem;
  color: #fa8660;
}

.structure-title {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: black;
}

.structure-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  font-weight: 300;
  color: black;
}

/* Stats Grid */
.structure-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.structure-stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.structure-stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.structure-stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  color: white;
}

.structure-stat-total .structure-stat-icon {
  background: linear-gradient(135deg, #1e40af, #3730a3);
}

.structure-stat-progress .structure-stat-icon {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.structure-stat-completed .structure-stat-icon {
  background: linear-gradient(135deg, #10b981, #059669);
}

.structure-stat-inactive .structure-stat-icon {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.structure-stat-content {
  flex: 1 1;
}

.structure-stat-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1e293b;
  line-height: 1;
}

.structure-stat-label {
  font-size: 1rem;
  color: #64748b;
  font-weight: 500;
}

/* Controls Section */
.structure-controls {
  max-width: 1400px;
  margin: 0 auto 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.structure-controls-left {
  display: flex;
  gap: 1rem;
  flex: 1 1;
}

.structure-controls-right {
  display: flex;
  gap: 1rem;
}

/* Search Container */
.structure-search-container {
  position: relative;
  flex: 1 1;
  max-width: 400px;
}

.structure-search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  font-size: 1rem;
}

.structure-search-input {
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 2.75rem;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.structure-search-input:focus {
  outline: none;
  box-shadow: 0 4px 20px rgba(175, 81, 30, 0.3);
  transform: translateY(-2px);
}

.structure-search-input::placeholder {
  color: #94a3b8;
}

/* Filter Container */
.structure-filter-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 0.875rem 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.structure-filter-icon {
  color: #64748b;
  font-size: 1rem;
}

.structure-filter-select {
  border: none;
  background: transparent;
  font-size: 1rem;
  color: #1e293b;
  cursor: pointer;
  outline: none;
  font-weight: 500;
}

/* View Toggle */
.structure-view-toggle {
  display: flex;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 0.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.structure-view-btn {
  padding: 0.75rem;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
  font-size: 1rem;
}

.structure-view-btn:hover {
  color: #de7100;
}

.structure-view-active {
    background: #de7100;
    color: white !important;
}

/* Projects Section */
.structure-projects-section {
  max-width: 1400px;
  margin: 0 auto;
}

.structure-projects-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 2rem;
}

.structure-list-view {
  grid-template-columns: 1fr;
}

.structure-project-card {
  background: white;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

.structure-project-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.structure-card-header {
  padding: 2rem 2rem 1rem;
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
}
.structure-building-icon-container {
    width: 45px;
    height: 45px;
    background: linear-gradient(135deg, #e97e02, #d85200);
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;
}
.structure-building-icon-container:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 25px rgba(175, 69, 30, 0.3);
}

.structure-building-icon {
  color: white;
  font-size: 2rem;
}

.structure-project-info {
  flex: 1 1;
}

.structure-project-name {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
    line-height: 1.3;
}
.structure-project-location {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
}

.structure-location-icon {
  color: #1e40af;
}

.structure-status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.structure-status-icon {
  font-size: 1.5rem;
}

.structure-status-progress {
  color: #f59e0b;
}

.structure-status-complete {
  color: #10b981;
}

.structure-status-inactive {
  color: #ef4444;
}

.structure-status-default {
  color: #64748b;
}

.structure-status-badge {
    padding: 0.375rem 0.875rem;
    border-radius: 20px;
    font-size: 7px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.structure-status-badge.structure-status-progress {
  background: #fef3c7;
  color: #d97706;
}

.structure-status-badge.structure-status-complete {
  background: #d1fae5;
  color: #059669;
}

.structure-status-badge.structure-status-inactive {
  background: #fee2e2;
  color: #dc2626;
}

.structure-status-badge.structure-status-default {
  background: #f1f5f9;
  color: #64748b;
}

.structure-card-body {
  padding: 0 2rem 1rem;
}

.structure-project-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.structure-detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.structure-detail-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.structure-detail-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e293b;
}

/* Progress Section */
.structure-progress-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1rem;
  border: 1px solid #e2e8f0;
}

.structure-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.structure-progress-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.structure-progress-percentage {
  font-size: 0.875rem;
  font-weight: 700;
  color: #af401e;
}

.structure-progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.structure-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #e94002, #d85200);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.structure-card-footer {
  padding: 1rem 2rem 2rem;
}

.structure-view-details-btn {
    width: 100%;
    padding: 10px;
    background: linear-gradient(135deg, #e97502, #d85200);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}
.structure-view-details-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(175, 83, 30, 0.3);
}

.structure-btn-icon {
  font-size: 1rem;
}

/* Empty State */
.structure-empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: white;
}

.structure-empty-icon {
  font-size: 5rem;
  color: rgba(255, 255, 255, 0.3);
  margin-bottom: 1.5rem;
}

.structure-empty-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.structure-empty-description {
  font-size: 1.125rem;
  opacity: 0.8;
  max-width: 500px;
  margin: 0 auto;
}

/* List View Specific Styles */
.structure-list-view .structure-project-card {
  border-radius: 16px;
}

.structure-list-view .structure-card-header {
  padding: 1.5rem 2rem 1rem;
}

.structure-list-view .structure-building-icon-container {
  width: 60px;
  height: 60px;
}

.structure-list-view .structure-building-icon {
  font-size: 1.75rem;
}

.structure-list-view .structure-project-details {
  grid-template-columns: repeat(4, 1fr);
}

.structure-list-view .structure-progress-section {
  margin-top: 1rem;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .structure-projects-container {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
}

@media (max-width: 768px) {
  .structure-main-container {
    padding: 1rem;
  }

  .structure-title {
    font-size: 2rem;
  }

  .structure-title-icon {
    font-size: 2.5rem;
  }

  .structure-stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
  }

  .structure-stat-card {
    padding: 1.5rem;
  }

  .structure-stat-icon {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }

  .structure-stat-number {
    font-size: 2rem;
  }

  .structure-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .structure-controls-left {
    flex-direction: column;
  }

  .structure-controls-right {
    justify-content: center;
  }

  .structure-projects-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .structure-project-card {
    border-radius: 20px;
  }

  .structure-card-header {
    padding: 1.5rem 1.5rem 1rem;
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .structure-project-info {
    text-align: center;
  }

  .structure-card-body {
    padding: 0 1.5rem 1rem;
  }

  .structure-project-details {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .structure-card-footer {
    padding: 1rem 1.5rem 1.5rem;
  }

  .structure-list-view .structure-project-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .structure-title-section {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .structure-title {
    font-size: 1.75rem;
  }

  .structure-title-icon {
    font-size: 2rem;
  }

  .structure-stats-grid {
    grid-template-columns: 1fr;
  }

  .structure-search-input {
    padding: 0.75rem 1rem 0.75rem 2.5rem;
  }

  .structure-building-icon-container {
    width: 60px;
    height: 60px;
  }

  .structure-building-icon {
    font-size: 1.75rem;
  }

  .structure-project-name {
    font-size: 1.25rem;
  }
}

/* Animation Classes */
@keyframes structure-fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.structure-project-card {
  animation: structure-fadeInUp 0.6s ease-out;
}

.structure-project-card:nth-child(2) {
  animation-delay: 0.1s;
}

.structure-project-card:nth-child(3) {
  animation-delay: 0.2s;
}

.structure-project-card:nth-child(4) {
  animation-delay: 0.3s;
}

/* Accessibility */
.structure-search-input:focus,
.structure-filter-select:focus {
  outline: 2px solid #af511e;
  outline-offset: 2px;
}

button:focus-visible {
  outline: 2px solid #af471e;
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .structure-controls,
  .structure-view-details-btn {
    display: none;
  }

  .structure-main-container {
    background: white;
  }

  .structure-project-card {
    page-break-inside: avoid;
    break-inside: avoid;
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .structure-project-card {
    border: 2px solid #1e293b;
  }

  .structure-status-badge {
    border: 1px solid currentColor;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .structure-project-card {
    animation: none;
  }

  .structure-project-card:hover {
    transform: none;
  }

  .structure-view-details-btn:hover {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/structure/structure.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;cACY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;AACA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    sans-serif;\n  background: #f8fafc;\n  color: #1e293b;\n  line-height: 1.6;\n}\n\n/* Main Container */\n.structure-main-container {\n  background-color: rgb(255, 255, 255);\n  padding: 2rem;\n}\n\n/* Header Section */\n.structure-header {\n  margin-bottom: 2rem;\n}\n\n.structure-header-content {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.structure-title-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  color: white;\n}\n\n.structure-title-icon {\n  font-size: 3rem;\n  color: #fa8660;\n}\n\n.structure-title {\n  font-size: 2.5rem;\n  font-weight: 800;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  color: black;\n}\n\n.structure-subtitle {\n  font-size: 1.125rem;\n  opacity: 0.9;\n  font-weight: 300;\n  color: black;\n}\n\n/* Stats Grid */\n.structure-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.structure-stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.structure-stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.structure-stat-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  color: white;\n}\n\n.structure-stat-total .structure-stat-icon {\n  background: linear-gradient(135deg, #1e40af, #3730a3);\n}\n\n.structure-stat-progress .structure-stat-icon {\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n}\n\n.structure-stat-completed .structure-stat-icon {\n  background: linear-gradient(135deg, #10b981, #059669);\n}\n\n.structure-stat-inactive .structure-stat-icon {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n}\n\n.structure-stat-content {\n  flex: 1;\n}\n\n.structure-stat-number {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: #1e293b;\n  line-height: 1;\n}\n\n.structure-stat-label {\n  font-size: 1rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* Controls Section */\n.structure-controls {\n  max-width: 1400px;\n  margin: 0 auto 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.structure-controls-left {\n  display: flex;\n  gap: 1rem;\n  flex: 1;\n}\n\n.structure-controls-right {\n  display: flex;\n  gap: 1rem;\n}\n\n/* Search Container */\n.structure-search-container {\n  position: relative;\n  flex: 1;\n  max-width: 400px;\n}\n\n.structure-search-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n  font-size: 1rem;\n}\n\n.structure-search-input {\n  width: 100%;\n  padding: 0.875rem 1rem 0.875rem 2.75rem;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.structure-search-input:focus {\n  outline: none;\n  box-shadow: 0 4px 20px rgba(175, 81, 30, 0.3);\n  transform: translateY(-2px);\n}\n\n.structure-search-input::placeholder {\n  color: #94a3b8;\n}\n\n/* Filter Container */\n.structure-filter-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 12px;\n  padding: 0.875rem 1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.structure-filter-icon {\n  color: #64748b;\n  font-size: 1rem;\n}\n\n.structure-filter-select {\n  border: none;\n  background: transparent;\n  font-size: 1rem;\n  color: #1e293b;\n  cursor: pointer;\n  outline: none;\n  font-weight: 500;\n}\n\n/* View Toggle */\n.structure-view-toggle {\n  display: flex;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 12px;\n  padding: 0.25rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.structure-view-btn {\n  padding: 0.75rem;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #64748b;\n  font-size: 1rem;\n}\n\n.structure-view-btn:hover {\n  color: #de7100;\n}\n\n.structure-view-active {\n    background: #de7100;\n    color: white !important;\n}\n\n/* Projects Section */\n.structure-projects-section {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.structure-projects-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 2rem;\n}\n\n.structure-list-view {\n  grid-template-columns: 1fr;\n}\n\n.structure-project-card {\n  background: white;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.structure-project-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.structure-card-header {\n  padding: 2rem 2rem 1rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n}\n.structure-building-icon-container {\n    width: 45px;\n    height: 45px;\n    background: linear-gradient(135deg, #e97e02, #d85200);\n    border-radius: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    transition: all 0.3s ease;\n}\n.structure-building-icon-container:hover {\n  transform: scale(1.05);\n  box-shadow: 0 8px 25px rgba(175, 69, 30, 0.3);\n}\n\n.structure-building-icon {\n  color: white;\n  font-size: 2rem;\n}\n\n.structure-project-info {\n  flex: 1;\n}\n\n.structure-project-name {\n    font-size: 20px;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n    line-height: 1.3;\n}\n.structure-project-location {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #64748b;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.structure-location-icon {\n  color: #1e40af;\n}\n\n.structure-status-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.structure-status-icon {\n  font-size: 1.5rem;\n}\n\n.structure-status-progress {\n  color: #f59e0b;\n}\n\n.structure-status-complete {\n  color: #10b981;\n}\n\n.structure-status-inactive {\n  color: #ef4444;\n}\n\n.structure-status-default {\n  color: #64748b;\n}\n\n.structure-status-badge {\n    padding: 0.375rem 0.875rem;\n    border-radius: 20px;\n    font-size: 7px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.structure-status-badge.structure-status-progress {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.structure-status-badge.structure-status-complete {\n  background: #d1fae5;\n  color: #059669;\n}\n\n.structure-status-badge.structure-status-inactive {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.structure-status-badge.structure-status-default {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.structure-card-body {\n  padding: 0 2rem 1rem;\n}\n\n.structure-project-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.structure-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.structure-detail-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.structure-detail-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Progress Section */\n.structure-progress-section {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 1rem;\n  border: 1px solid #e2e8f0;\n}\n\n.structure-progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.structure-progress-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.structure-progress-percentage {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #af401e;\n}\n\n.structure-progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.structure-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #e94002, #d85200);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.structure-card-footer {\n  padding: 1rem 2rem 2rem;\n}\n\n.structure-view-details-btn {\n    width: 100%;\n    padding: 10px;\n    background: linear-gradient(135deg, #e97502, #d85200);\n    color: white;\n    border: none;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n.structure-view-details-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(175, 83, 30, 0.3);\n}\n\n.structure-btn-icon {\n  font-size: 1rem;\n}\n\n/* Empty State */\n.structure-empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: white;\n}\n\n.structure-empty-icon {\n  font-size: 5rem;\n  color: rgba(255, 255, 255, 0.3);\n  margin-bottom: 1.5rem;\n}\n\n.structure-empty-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin-bottom: 0.75rem;\n}\n\n.structure-empty-description {\n  font-size: 1.125rem;\n  opacity: 0.8;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* List View Specific Styles */\n.structure-list-view .structure-project-card {\n  border-radius: 16px;\n}\n\n.structure-list-view .structure-card-header {\n  padding: 1.5rem 2rem 1rem;\n}\n\n.structure-list-view .structure-building-icon-container {\n  width: 60px;\n  height: 60px;\n}\n\n.structure-list-view .structure-building-icon {\n  font-size: 1.75rem;\n}\n\n.structure-list-view .structure-project-details {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.structure-list-view .structure-progress-section {\n  margin-top: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .structure-projects-container {\n    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .structure-main-container {\n    padding: 1rem;\n  }\n\n  .structure-title {\n    font-size: 2rem;\n  }\n\n  .structure-title-icon {\n    font-size: 2.5rem;\n  }\n\n  .structure-stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1rem;\n  }\n\n  .structure-stat-card {\n    padding: 1.5rem;\n  }\n\n  .structure-stat-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 1.5rem;\n  }\n\n  .structure-stat-number {\n    font-size: 2rem;\n  }\n\n  .structure-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .structure-controls-left {\n    flex-direction: column;\n  }\n\n  .structure-controls-right {\n    justify-content: center;\n  }\n\n  .structure-projects-container {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .structure-project-card {\n    border-radius: 20px;\n  }\n\n  .structure-card-header {\n    padding: 1.5rem 1.5rem 1rem;\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n\n  .structure-project-info {\n    text-align: center;\n  }\n\n  .structure-card-body {\n    padding: 0 1.5rem 1rem;\n  }\n\n  .structure-project-details {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .structure-card-footer {\n    padding: 1rem 1.5rem 1.5rem;\n  }\n\n  .structure-list-view .structure-project-details {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .structure-title-section {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.5rem;\n  }\n\n  .structure-title {\n    font-size: 1.75rem;\n  }\n\n  .structure-title-icon {\n    font-size: 2rem;\n  }\n\n  .structure-stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .structure-search-input {\n    padding: 0.75rem 1rem 0.75rem 2.5rem;\n  }\n\n  .structure-building-icon-container {\n    width: 60px;\n    height: 60px;\n  }\n\n  .structure-building-icon {\n    font-size: 1.75rem;\n  }\n\n  .structure-project-name {\n    font-size: 1.25rem;\n  }\n}\n\n/* Animation Classes */\n@keyframes structure-fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.structure-project-card {\n  animation: structure-fadeInUp 0.6s ease-out;\n}\n\n.structure-project-card:nth-child(2) {\n  animation-delay: 0.1s;\n}\n\n.structure-project-card:nth-child(3) {\n  animation-delay: 0.2s;\n}\n\n.structure-project-card:nth-child(4) {\n  animation-delay: 0.3s;\n}\n\n/* Accessibility */\n.structure-search-input:focus,\n.structure-filter-select:focus {\n  outline: 2px solid #af511e;\n  outline-offset: 2px;\n}\n\nbutton:focus-visible {\n  outline: 2px solid #af471e;\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .structure-controls,\n  .structure-view-details-btn {\n    display: none;\n  }\n\n  .structure-main-container {\n    background: white;\n  }\n\n  .structure-project-card {\n    break-inside: avoid;\n    box-shadow: none;\n    border: 1px solid #e2e8f0;\n  }\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .structure-project-card {\n    border: 2px solid #1e293b;\n  }\n\n  .structure-status-badge {\n    border: 1px solid currentColor;\n  }\n}\n\n/* Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n  .structure-project-card {\n    animation: none;\n  }\n\n  .structure-project-card:hover {\n    transform: none;\n  }\n\n  .structure-view-details-btn:hover {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
